import AWSS3Provider from './AWSS3Provider';
export { AWSS3Provider };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/storage/lib-esm/Providers/index.js
// module id = 1348
// module chunks = 0